import React from 'react'
import styled from 'styled-components'

import { RefreshIcon } from '../icons/refresh-icon'
import useText from '../hooks/useText'

import { Button } from './Button'

const SDiv = styled.div`
    flex: 1 1 auto;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.brandColors.CA_Lightest_Gray};
    flex-grow: 1;
    font-weight: 500;
    color: #797979;
    flex-flow: column;
    gap: ${({ theme }) => theme.sizing.margin.m};

    & > * {
        color: #797979;
        border-color: #797979;
    }
`

interface IComponentProps {
    emptyText?: string
    isFetching?: boolean
    action?: () => void
    label?: string
    icon?: React.ReactElement
}

const EmptyListRefresh = ({ isFetching, emptyText, action, icon, label }: IComponentProps) => {
    const text = useText()
    return (
        <SDiv>
            {action && !isFetching ? (
                <>
                    <span>{emptyText}</span>
                    <Button
                        size="xs"
                        primary={false}
                        label={label ? label : text('btnRefresh')}
                        onClick={() => action()}
                        icon={
                            icon ? (
                                icon
                            ) : (
                                <span className="mt-2">
                                    <RefreshIcon size={14} />
                                </span>
                            )
                        }
                    />
                </>
            ) : (
                <div className="shimmer-container shimmer-small"></div>
            )}
        </SDiv>
    )
}

export default EmptyListRefresh
